import { render, staticRenderFns } from "./ChangeTaxNumber.vue?vue&type=template&id=01c49d47"
import script from "./ChangeTaxNumber.vue?vue&type=script&lang=js"
export * from "./ChangeTaxNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports